import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ReactElement } from 'react'

interface MenuInfo {
  text?: string | ReactElement
  to?: string
  subMenuItems?: any
  parentMenu?: string
  menuName?: string // 菜单名称，用于标识菜单，不受翻译影响
}

interface MenuState {
  currentMenu: MenuInfo
}

const initialState: MenuState = {
  currentMenu: {},
}

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setMenuInfo: (state, action: PayloadAction<MenuInfo>) => {
      state.currentMenu = action.payload
    },
    clearMenuInfo: state => {
      state.currentMenu = {}
    },
  },
})

export const { setMenuInfo, clearMenuInfo } = menuSlice.actions
export default menuSlice.reducer
